import { render } from "./ButtonComp.vue?vue&type=template&id=492e8c4d"
import script from "./ButtonComp.vue?vue&type=script&lang=js"
export * from "./ButtonComp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__